import { Logo } from "@/components/Logo";
import { ShieldCheck, Cpu, FileCheck, Radar } from "lucide-react";

const HIGHLIGHTS = [
  { icon: ShieldCheck, text: "Continuous SAST, DAST, cloud & secret scanning" },
  { icon: Cpu, text: "AI Security Engineer that prioritizes & remediates" },
  { icon: FileCheck, text: "SOC 2, ISO 27001, GDPR & HIPAA readiness" },
  { icon: Radar, text: "Verified fixes — find it, fix it, prove it" },
];

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-bg">
      {/* Left brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between p-12 border-r border-line overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-40" />
        <div className="absolute inset-0 radial-fade" />
        <div className="relative">
          <Logo size="lg" />
        </div>
        <div className="relative">
          <h2 className="font-display text-3xl font-extrabold tracking-tight leading-tight text-ink">
            Enterprise-grade security capability.<br />
            <span className="text-cyber">Built for lean teams.</span>
          </h2>
          <div className="mt-8 space-y-4">
            {HIGHLIGHTS.map((h) => (
              <div key={h.text} className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg bg-cyber/10 flex items-center justify-center shrink-0">
                  <h.icon size={17} className="text-cyber" />
                </div>
                <span className="text-sm text-muted">{h.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="relative flex items-center gap-2 text-xs font-mono text-muted">
          <span className="w-2 h-2 rounded-full bg-secure live-dot" /> SOC 2-ready infrastructure
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex items-center justify-center p-6 sm:p-10">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo /></div>
          {children}
        </div>
      </div>
    </div>
  );
}
